var React = require('react');

function GraphUp60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M59 40H1a1 1 0 0 1-1-1V.999a1 1 0 0 1 2 0V38h57a1 1 0 1 1 0 2zm-7-25a1 1 0 0 1-1-1V8.32L34.687 23.726a.996.996 0 0 1-1.434-.061l-7.375-8.298-13.26 10.419a.995.995 0 0 1-1.404-.169 1 1 0 0 1 .168-1.404l14-10.999a1.001 1.001 0 0 1 1.365.121l7.316 8.23L49.484 7H44a1 1 0 1 1 0-1.999h8l.012.002a.982.982 0 0 1 .272.055c.037.011.077.01.111.025.04.017.071.051.109.073.075.045.151.088.212.15l.011.008c.032.033.044.076.071.113.047.066.097.129.128.205.029.074.035.15.046.228.007.047.028.09.028.14v8a1 1 0 0 1-1 1z","key":1})]);
}

GraphUp60px.displayName = "GraphUp60px";

GraphUp60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 40"};

module.exports = GraphUp60px;

GraphUp60px.default = GraphUp60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/graph-up-60px.svg
// module id = 1194
// module chunks = 0